import React, { useState, useEffect } from 'react';
import InputDo from './InputDo';
import CariPo from './CariPo';

function Do() {
  const [pasangData, setPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [showInputForm, setShowInputForm] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedPasang, setSelectedPasang] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [showCariPo, setShowCariPo] = useState(false);
  const schema = localStorage.getItem('schema');

  const today = new Date();
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() + 30);

const formatDate = (dateInput) => {
  if (!dateInput) return '';

  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date)) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day   = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;  
};


  const [start_date, setStartDate] = useState(formatDate(today));
  const [end_date, setEndDate] = useState(formatDate(today));

  const fetchPasangData = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!start_date || !end_date) {
        throw new Error('Tanggal awal dan akhir harus diisi');
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=do&schema=${schema}&start_date=${start_date}&end_date=${end_date}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setPasangData(data);
        setFilteredData(data);  
      } else {
        throw new Error('Invalid data format from API');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (start_date && end_date) {
      fetchPasangData();
    }
  }, [start_date, end_date]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = pasangData.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(query.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const handleEdit = async (pasang) => {
    try {
      const id = pasang.NO_TRANSAKSI;
      const masterResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=do_id&schema=${schema}&id=${id}`);
      const masterData = await masterResponse.json();

      setSelectedPasang({
        master: masterData[0]
      });

      setEditMode(true);
      setShowInputForm(true);
    } catch (error) {
      console.error("Error fetching edit data:", error);
      alert("Gagal memuat data untuk edit.");
    }
  };

  const handleSave = () => {
    setShowInputForm(false);
    fetchPasangData();
  };

  const handleCancel = () => {
    setShowInputForm(false);
    setSelectedPasang(null);
  };

  const handlePoSelect = (selectedPo) => {

  const formData = {
    KOTA_ASAL: selectedPo.KOTA_ASAL,
    KOTA_TUJUAN: selectedPo.KOTA_TUJUAN,
    SUBCITY: selectedPo.SUBCITY,
    JNS_KENDARAAN: selectedPo.JNS_KENDARAAN,
    JNS_MUATAN: selectedPo.JNS_MUATAN,
    NO_PO: selectedPo.NO_PO,
    TGL_PO: selectedPo.TGL_PO,
    KD_REKANAN: selectedPo.KD_REKANAN,
    NAMAREKANAN: selectedPo.NAMAREKANAN,
    NAMA_TTD1: selectedPo.NAMA_TTD1,
    NO_PO_TRANS: selectedPo.NO_TRANSAKSI,
  };

  setSelectedPasang({ master: formData, isNew: true });
  setEditMode(false);
  setShowCariPo(false);     
  setShowInputForm(true); 
};


  return (
    <div>
      <div className="section-header">

        <h2>Delivery Order</h2>

        <div className="responsive-filter">
          <label>Periode: </label>
          <input type="date" value={start_date} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={end_date} onChange={(e) => setEndDate(e.target.value)} />
          <button onClick={() => fetchPasangData()}>Refresh</button>
        </div>

        {!showInputForm && (
          <div className="action-bar">
            <div className="left-section">
              <button
                className="add-button"
                onClick={() => {
                  setShowCariPo(true);
                }}
              >
                Tambah
              </button>
            </div>
            <div className="right-section">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Cari data..."
                className="search-input"
                style={{ width: '100px' }}
              />
            </div>
          </div>
        )}


      </div> 

      {showCariPo && (
        <CariPo
          onSelect={handlePoSelect}
          onCancel={() => setShowCariPo(false)}
        />
      )}

      {showInputForm ? (
        <InputDo
          onCancel={handleCancel}
          onSave={handleSave}
          editMode={editMode}
          pasang={selectedPasang}
          title={editMode ? 'Edit DO' : 'Input DO'}
        />
      ) : (
        <div style={{ overflowX: 'auto' }}>
                <table className="responsive-table">
                  <thead>
                    <tr>
                      <th>Edit</th>                
                      <th onClick={() => handleSort('TGL_TRANSAKSI')}>Tanggal {getSortIcon('TGL_TRANSAKSI')}</th>
                      <th onClick={() => handleSort('NO_TRANSAKSI')}>No Transaksi {getSortIcon('NO_TRANSAKSI')}</th>
                      <th onClick={() => handleSort('NAMAREKANAN')}>Rekanan {getSortIcon('NAMAREKANAN')}</th>
                      <th onClick={() => handleSort('KOTA_ASAL')}>Asal {getSortIcon('KOTA_ASAL')}</th>
                      <th onClick={() => handleSort('KOTA_TUJUAN')}>Tujuan {getSortIcon('KOTA_TUJUAN')}</th>
                      <th onClick={() => handleSort('JNS_MUATAN')}>Muatan {getSortIcon('JNS_MUATAN')}</th>
                      <th onClick={() => handleSort('JNS_KENDARAAN')}>Jns Kend {getSortIcon('JNS_KENDARAAN')}</th>      
                      <th onClick={() => handleSort('SOPIR')}>Sopir {getSortIcon('SOPIR')}</th>
                      <th onClick={() => handleSort('KD_KENDARAAN')}>Kd Kend {getSortIcon('KD_KENDARAAN')}</th>
                      <th onClick={() => handleSort('NOPOL')}>Nopol {getSortIcon('NOPOL')}</th>                               
                      <th onClick={() => handleSort('STATUS')}>Status {getSortIcon('LSTATUS')}</th>
                      <th onClick={() => handleSort('LNAMA_TTD1')}>Nama TTD1 {getSortIcon('LNAMA_TTD1')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((item) => (
                      <tr key={item.ID}>
                        <td>
                          <button onClick={() => handleEdit(item)}>Edit</button>
                        </td>
                        <td>{item.TGL_TRANSAKSI}</td>
                        <td>{item.NO_TRANSAKSI}</td>
                        <td>{item.NAMAREKANAN}</td>
                        <td>{item.KOTA_ASAL}</td>
                        <td>{item.KOTA_TUJUAN}</td>
                        <td>{item.JNS_MUATAN}</td>
                        <td>{item.JNS_KENDARAAN}</td>
                        <td>{item.SOPIR}</td>
                        <td>{item.KD_KENDARAAN}</td>
                        <td>{item.NOPOL}</td>                  
                        <td>{item.LSTATUS}</td>
                        <td>{item.LNAMA_TTD1}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

        </div>
      )}


    </div>
  );
}

export default Do;
